module.exports = __webpack_public_path__ + "img/enisa.825b654e.png";